import React, { ReactNode } from 'react';
import { makeStyles } from '~/UIKit/Style';
import {
  GREEN,
  RED_DOT,
  WARNING,
  DISABLED,
  DRAWER_INACTIVE_SELECTION,
  CHIP_BACKGROUND_GREEN,
  CHIP_COLOR_GREEN,
  CHIP_BACKGROUND_RED,
  CHIP_COLOR_RED,
  CHIP_BACKGROUND_ORANGE,
  CHIP_COLOR_ORANGE,
  WHITE,
} from '~/Constants/Colors.constants';
import { FONT_SIZE_SMALL, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { Chip } from '@mui/material';

type Size = 'small' | 'medium';
export interface StatusTagProps {
  children: ReactNode;
  status: string;
  size?: Size;
  variant?: string;
}

const statusConstants = {
  success: {
    background: CHIP_BACKGROUND_GREEN,
    chipColor: GREEN,
    color: CHIP_COLOR_GREEN,
  },
  warning: {
    background: CHIP_BACKGROUND_ORANGE,
    chipColor: WARNING,
    color: CHIP_COLOR_ORANGE,
  },
  danger: {
    background: CHIP_BACKGROUND_RED,
    chipColor: RED_DOT,
    color: CHIP_COLOR_RED,
  },
  noStatus: {
    background: DRAWER_INACTIVE_SELECTION,
    chipColor: DISABLED,
  },
  info: {
    background: CHIP_COLOR_ORANGE,
    color: WHITE,
  },
} as any;

const useStyles = (status: string) => {
  const statusObj = statusConstants?.[status];

  return makeStyles({
    statusTag: {
      background: statusObj && statusObj.background,
      borderRadius: 4,
      color: statusObj && statusObj.color,
      fontWeight: 'bold',
      position: 'relative',
      textTransform: 'capitalize',
    },
    small: {
      fontSize: FONT_SIZE_SMALL,
      height: 20,
      lineHeight: 'normal',
    },
    medium: {
      fontSize: FONT_SIZE_SMALLISH,
      height: 24,
      lineHeight: 'normal',
    },
  });
};

export const StatusTag = ({ children, status, size }: StatusTagProps) => {
  const { classes, cx } = useStyles(status)();
  const sizeClass = size ? classes[size] : classes.small;
  return (
    <Chip
      data-testid="status-tag"
      component={'span'}
      label={children}
      size={size}
      className={cx(classes.statusTag, sizeClass)}
    />
  );
};
